// removed by extract-text-webpack-plugin
module.exports = {"container":"Activation__container___xynPc","item":"Activation__item___3MNL8","note":"Activation__note___3Q054","partner":"Activation__partner___dbSMT"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/Activation.less
 ** module id = 750
 ** module chunks = 0
 **/